import React from "react";
import { useSelector } from "react-redux";
import { selectPost } from "./postSlice";

const PostItem = () => {
  const post = useSelector(selectPost);
  const { author, idPost, title, subreddit, url } = post[0].data;
  return (
    <div key={idPost} className="postItem">
      <div>
        <h5 className="author">Posted By: {author}</h5>
        <h2>{subreddit}</h2>
      </div>
      <h3>{title}</h3>
      <img className="postItem-img" src={url} alt="" />
    </div>
  );
};

export default PostItem;
